import React, {Fragment, useEffect, useState} from "react";
import {connect} from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css';
import {Form, Row, Dropdown, FormLabel, FormGroup} from 'react-bootstrap'

import {getFilters, getOPKSFilters} from '../../../actions/FilterActions'
import {FilterItem, FilterAvailableDataPoints, DataPointItem} from "../DataFilter";
import Button from "react-bootstrap/Button";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import {setPreviousFilter, setFilter} from "../../../actions";
import OPKFilter from "./OPKFilter";

const FilterList = ({Filters: {available_filters, active_filter, previous_filter}, PlotData: {loading, active_plot, plot_data}, Indicators: {available_indicators}, getOPKSFilters, getFilters, setFilter, setPreviousFilter}) => {
    const [filterName, setFilterName] = useState('');
    const [displayFilters, setDisplayedFilters] = useState([]);
    useEffect(() => {const asyncWrapper = async () => { 
        getFilters();
        getOPKSFilters(true);
    }
    asyncWrapper()

        //eslint-disable-next-line
    }, []);
    useEffect(() => {
        const asyncWrapper = async () => { 
            getOPKSFilters(true);
        }
        asyncWrapper()
    },[window.location.href])

    const [style, setStyle] = useState({
        "overflowY": "auto",
        "height": "auto"
    });

    function dynamicSort(property) {
        return function (a, b) {
            return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        }
    }

    // useEffect(() => {
    //     const name = available_filters.filter(filter => active_filter.includes(filter.id));
    //     if (name.length > 0 && active_filter>0) {
    //
    //         setFilterName(name[0].opis);
    //         setPreviousFilter({[active_plot]: name[0].id})
    //     }
    // }, [active_filter,plot_data]);

    useEffect(() => {


        if (available_filters.length > 0 && Object.keys(available_indicators).length && active_plot) {

            const indicator = available_indicators.filter(indicator => indicator.nazwa === active_plot)[0];
            const filters = available_filters.filter(filter => indicator.grupa.includes(filter.id));
            setDisplayedFilters(filters);
            if (active_plot in previous_filter) {
                // setFilterName(available_filters.find(filter => filter.id===previous_filter[active_plot]).nazwa);
                setFilter(previous_filter[active_plot])

            } else {
                // setFilterName(filters[0].nazwa);
                setFilterName("Wybrano");
                setPreviousFilter({[active_plot]: filters[0].id});

                setFilter(filters[0])
            }
        }
    }, [active_plot]);

    const checkIfActivePlotNeedsOpkFilter = () => {
        if (available_indicators.length !== 0) {
            let active_indicator_exist = available_indicators.filter(x => x.nazwa === active_plot);
            if (active_indicator_exist.length !== 0) {
                if (active_indicator_exist[0].typ !== "EFP") {
                    return true
                }
            }
        }
        return false
    };


    return (<Fragment>


            {
                checkIfActivePlotNeedsOpkFilter()
                    ?
                    <div className={"okraglaczki nowaOkr"}>
                     <OPKFilter />
                    </div>
                    :
                    <Dropdown style={{"opacity": "1"}} className={"ml-auto justify-content-end"}>
                        {loading
                            ?
                            <Dropdown.Toggle block id="dropdown-basic" disabled={true} variant="" key={123456}
                                             style={{background: "#17728d"}} className={'m-0 btn-round wskButt'}>
                                Ładowanie Danych
                            </Dropdown.Toggle>
                            :
                            <Dropdown.Toggle block id="dropdown-basic" key={1234756} variant=""
                                             style={{background: "#17728d"}} className={' m-0 btn-round wskButt'}>
                                Filtruj Dane
                            </Dropdown.Toggle>
                        }


                        <Dropdown.Menu>

                            <Form.Group className={'p-1'} style={style}>
                                {(displayFilters.sort(dynamicSort('id')).map(filter => <FilterItem filter={filter}
                                                                                                   key={filter.nazwa}/>))}

                            </Form.Group>
                        </Dropdown.Menu>
                    </Dropdown>}
        </Fragment>
    )


};

const mapStateToProps = state => ({
    Filters: state.Filters,
    PlotData: state.PlotData,
    Indicators: state.Indicators

});
export default connect(mapStateToProps, {getFilters, setPreviousFilter, setFilter, getOPKSFilters})(FilterList)


const INDICATOR_DICT = {
    "wskaznik zyskownosci netto": "Zyskowność netto",
    "wskaznik zyskownosci dzialnosci operacyjnej": "Zyskowność działności operacyjnej",
    "wskaznik zyskownosci aktywow": "Zyskowność Aktywów",
    "wskaznik biezacej plynnosci": "Bieząca Płyność",
    "wskaznik szybkiej plynnosci": "Szybka płyność",
    "wskaznik rotacji naleznosci": "Rotacja naleznosci",
    "wskaznik rotacji zobowiazan": "Rotacja Zobowiazan",
    "wskaznik zadluzenia aktywow": "Zadłuzenie aktywów",
    "wskaznik wyplacalnosci": "Wypłacalność",
    "wskaznik obslugi dlugu": "Obsługa długu",
    "wskaznik finansowania majatku trwalego": "Finansowanie majątku trwałego",
    "wskaznik ekonomicznej wartosci dodanej kapitalu ludzkiego": "Ekonomiczna wartość kapitału ludzkiego",
    "wskaznik zysku ze sprzedazy na pracownika": "Zysk ze sprzedaży na pracownika"
};
